const yellow = 0xfacf5a;
const blue = 0x2080d5;

export { yellow, blue };
